import React from 'react';
import PropTypes from 'prop-types';
import Badge from '@/components/Badge';

const propTypes = {
  name: PropTypes.string.isRequired,
  children: PropTypes.node,
  badge: PropTypes.string
};

const titles = {
  schedule_activity: 'Agendar atividade automaticamente',
  create_deal: 'Criar negócio automaticamente',
  send_email: 'Enviar e-mail automaticamente',
  send_whatsapp: 'Enviar mensagem automaticamente'
};

function Section(props) {
  const { name, children, badge } = props;

  const title = titles[name] ?? 'Automações criadas';

  return (
    <section>
      <div className='d-flex align-items-center gap-1'>
        <h4 className='my-4'>{title}</h4>
        {badge && (
          <Badge className='height-1'>
            {badge}
          </Badge>)
        }
      </div>

      <div className='d-flex flex-wrap gap-4'>
        {children}
      </div>

      <hr className='mt-2' />
    </section>
  );
}

Section.propTypes = propTypes;

export default Section;
